import { useState } from "react";
import DialogModal from "../../Modals/dialogModal";
import CalendarColorClasses from "./CalendarColorClasses";
import { createPersonalEvent } from "../../../Services/Calendar";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function CreateEvent({ showModal, setShowModal, loadEvents }) {
    const [newEvent, setNewEvent] = useState({ title: "", start: "", end: "", props: { color: "bc-green" } });

    const [color, setColor] = useState("bc-green");
    const [description, setDescription] = useState("");
    const [showModal2, setShowModal2] = useState(false)
    const [showString, setShowString] = useState(false)

    async function handleAddEvent(props) {
        if (!newEvent.title || !newEvent.start || !newEvent.end || !newEvent.props) {
            setShowModal2(true)
            setShowString("Complete título, fecha de inicio y fecha de fin.")
            return
        }

        let rsp = await createPersonalEvent(newEvent);


        if (rsp?.Error === false) {
            await loadEvents();
            setShowModal(false);
        } else {
            setShowModal2(true)
            setShowString("El evento no pudo ser creado en este momento.")
        }

    }

    return (
        <>

            {/* Create Event View Modal */}
            <DialogModal showModal={showModal} setShowModal={setShowModal} showClose={false} centerVertically={false} padding={0} contentWidth={"100%"}
                styles={{
                    container: {
                        height: "fit-content",
                        maxWidth: "85%",
                        backgroundColor: "rgb(236, 236, 236)",
                        width: "70vw"
                    },
                    content: {
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px"
                    }
                }}
            >
                <h3 className='modalHeader'>Crear Evento</h3>
                <div className='calendar-input'>

                    <input type="text" placeholder='Titulo'
                        value={newEvent.title} onChange={(e) => setNewEvent({ ...newEvent, title: e.target.value })} />
                    <div className="input-container">
                        <label htmlFor="fecha-inicio">Fecha de Inicio</label>
                        <input type="datetime-local" placeholder="Fecha de inicio" className="datepicker" id="fecha-inicio" name="fecha-inicio"
                            selected={newEvent.start} onChange={e => setNewEvent({ ...newEvent, start: e.target.value.replace('T', ' ') })} />
                    </div>
                    <div className="input-container">
                        <label htmlFor="fecha-fin">Fecha de Fin</label>
                        <input type="datetime-local" placeholder="Fecha de termino" id="fecha-fin" name="fecha-fin"
                            selected={newEvent.end} onChange={(e) => setNewEvent({ ...newEvent, end: e.target.value.replace('T', ' ') })} />
                    </div>
                    <div className="input-container">
                        <label htmlFor="estilo">Estilo</label>
                        <select className={'colorClass-select' + " " + color} value={color} onChange={(e) => { setNewEvent({ ...newEvent, props: { ...newEvent.props, color: e.target.value } }); setColor(e.target.value); }} id="estilo" name="estilo">
                            {CalendarColorClasses.map((color, index) => (
                                <option key={index} className={color[0]} value={color[0]}>{color[1]}</option>
                            ))}
                        </select>
                    </div>
                    <ReactQuill
                        theme="snow"
                        onChange={(content) => setNewEvent({ ...newEvent, description: content })}
                    />
                    {
                        //<textarea name="textarea" rows="5" cols="50" placeholder='Descripción del Evento' onChange={(e) => setNewEvent({...newEvent, body:e.target.value})}></textarea>
                    }
                    <button className='green-btn setpointer' style={{ width: "70%", marginInline: "auto" }} onClick={handleAddEvent}>Agregar nuevo evento</button>
                    <button className='green-btn setpointer' style={{ width: "70%", marginInline: "auto" }} onClick={() => setShowModal(false)}>Cancelar</button>
                </div>

            </DialogModal>
            <DialogModal showModal={showModal2} setShowModal={setShowModal2}>
                <h3>{showString}</h3>
            </DialogModal>
        </>
    )
}